import { useMemo } from "react";
import { useTable } from "react-table";
import { formatCurrency } from "../../../helpers";

const useReturnItemsTable = ({
  items: itemsProp,
  returnDetails,
  currencyCode = "NGN",
}) => {
  const items = useMemo(
    () => itemsProp || returnDetails?.items || [],
    [itemsProp, returnDetails?.items],
  );

  const columns = useMemo(
    () => [
      {
        Header: "#",
        accessor: (_row, i) => i + 1,
        id: "index",
        Cell: ({ row }) => <span>{row.index + 1}</span>,
      },
      {
        Header: "Product Name",
        accessor: "product_name",
        Cell: ({ cell: { value }, row }) => (
          <div>
            <div className="font-weight-medium">{value || "Product"}</div>
            {row?.original?.variant_name && (
              <small className="text-muted">
                Variant: {row.original.variant_name}
              </small>
            )}
          </div>
        ),
      },
      {
        Header: "ID",
        accessor: "id",
        Cell: ({ cell: { value } }) => <span>{value || "-"}</span>,
      },
      {
        Header: "Returned Quantity",
        accessor: "quantity",
        Cell: ({ cell: { value } }) => (
          <span className="font-weight-semibold">{value ?? 1}</span>
        ),
      },
      {
        Header: "Unit Price",
        accessor: "unit_price",
        Cell: ({ cell: { value } }) => (
          <span>
            {formatCurrency({
              value: value || 0,
              currencyCode,
            })}
          </span>
        ),
      },
      {
        Header: "Total Amount",
        accessor: "amount",
        Cell: ({ cell: { value }, row }) => (
          <span className="font-weight-semibold">
            {formatCurrency({
              value:
                value ??
                (row?.original?.quantity || 1) *
                  (row?.original?.unit_price || 0),
              currencyCode,
            })}
          </span>
        ),
      },
    ],
    [currencyCode],
  );

  const instance = useTable({
    columns,
    data: items,
  });

  return {
    instance,
    items,
  };
};

export default useReturnItemsTable;
